import type { CatalogueEntry } from "../types";
import imageLight from "../images/electoral-boundaries.light.webp";
import imageDark from "../images/electoral-boundaries.dark.webp";

export const entry: CatalogueEntry = {
  slug: "electoral-boundaries",
  displayName: `Electoral Boundaries`,
  datasetProductCode: `ELECTORAL BOUNDARIES`,
  subtitle: `Digital Mapping of Electoral Divisions.`,
  shortDescription: `Electoral Boundaries is a national digital dataset of Australia's electoral divisions or electorates. The Electoral Boundaries dataset has two layers: Commonwealth Electoral Boundaries (CEB) and State Electoral Boundaries (SEB).

Electoral Boundaries are based on government data provided by the appropriate authorities. The Commonwealth and State/Territory Governments collect data to delineate the areas covered by each tier of government within Australia.`,
  metadata: {
    dateAdded: 1630368000000,
    dataType: ["Polygons"],
    totalFeatureCount: 9954,
    updateFrequency: `Quarterly`,
    license: `CC BY 4.0`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/en/stable/electoral_boundaries.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/en/stable/electoral_boundaries.html`,
  imageLight,
  imageDark,
  searchTags: `National Electoral Boundaries Geoscape Electoral Boundaries Administrative Boundaries Districts Elections Electoral Mapping Political Analysis Votes Voting Districts`,
  detail: () => import("../details/electoral-boundaries").then((m) => m.detail),
};

export default entry;
